import React from "react";
import { Button } from "antd";
import "./AboutUs.scss";
import AboutUsSvg from "./about-us.svg";
import AboutUs1Svg from "./about-us-img1.svg";

const VissionComponent = ({ title, description, type = 'row' }) => {
  return (
    <div className={type === 'row' ? 'mission-container' : "vission-container"}>
      <div className="text">
        <h1>{description}</h1>
      </div>
      <div className="title">
        <h1>{title}</h1>
      </div>
    </div>
  );
};
export const AboutUs = () => {
  return (
    <div className="AboutUs-container">
      <div className="AboutUs-container-inner">
        <div className="left-section">
          <h1>About Us</h1>
        </div>
        <div className="right-section">
          
        At Sprintly, we specialize in providing professional IT consultancy services to help businesses excel. Our dedicated team of technical and software professionals is committed to driving your business towards success through expert guidance and support.
            <br />
            <br /> We are a emerging company specialising in Android/iOS mobile application development, B2B system integration, information security professional services, and technical support. Our mission is to help you overcome digitisation challenges, enabling you to concentrate on your core business while we assume responsibility for the digital journey.
          
        </div>
      </div>
      <div className="center-section-top">
        <img src={AboutUs1Svg} />
      </div>
      <VissionComponent title="Mission" description="Our mission is to expedite startup products to market with excellence in software development. Committed to delivering top-tier mobile apps and web solutions, we aim to be the driving force that ensures startups achieve market entry efficiently, without compromising on quality. Guided by a dedication to innovation, collaboration, and client satisfaction, we provide the technological foundation that empowers startups to not only enter the market but also to thrive and make a lasting impact."
      />
         <VissionComponent title="Vision" type='reverse' description="To be the cornerstone of startup success, our company envisions a future where our software development expertise accelerates innovative products to market. We strive to be the trusted partner for startups, ushering in a digital era where high-quality solutions and exceptional services drive their growth and market impact."
      />
      <div className="center-section">
        <img src={AboutUsSvg} />
      </div>
    </div>
  );
};
